import { parseAsInteger, useQueryStates } from 'nuqs';

import { PAGE_SIZE } from '../constants';

const myRequestsSearchParams = {
  page: parseAsInteger.withDefault(1),
  pageSize: parseAsInteger.withDefault(PAGE_SIZE),
};

type TUseMyRequestsPaginationResult = {
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
};

// `useTableState` seeds its own pageIndex once, at mount. The table owns it
// afterwards; this hook only mirrors that value into the URL.
export const useMyRequestsPagination = (): TUseMyRequestsPaginationResult => {
  const [urlState, setUrlState] = useQueryStates(myRequestsSearchParams);

  const onPageChange = (page: number): void => {
    setUrlState({ page });
  };

  const onPageSizeChange = (pageSize: number): void => {
    setUrlState({ pageSize, page: 1 });
  };

  return {
    page: urlState.page,
    pageSize: urlState.pageSize,
    onPageChange,
    onPageSizeChange,
  };
};
